import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'eq-card',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './eq-card.component.html',
  styleUrl: './eq-card.component.scss',
})
export class EqCardComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() class: string = ''
}
